import styles from './LanguageToggle.module.css';

export const LanguageToggle = ({ locale, onChange }) => (
  <div className={styles.toggle}>
    <button
      type="button"
      className={`${styles.button} ${locale === 'en' ? styles.buttonActive : ''}`}
      onClick={() => onChange('en')}
      aria-pressed={locale === 'en'}
      aria-label="English"
    >
      <abbr className={styles.abbr} title="English">
        EN
      </abbr>
    </button>
    <button
      type="button"
      className={`${styles.button} ${locale === 'fa' ? styles.buttonActive : ''}`}
      onClick={() => onChange('fa')}
      aria-pressed={locale === 'fa'}
      aria-label="فارسی"
    >
      <abbr className={styles.abbr} title="فارسی">
        FA
      </abbr>
    </button>
  </div>
);
